import React, { PureComponent } from 'react';
import axios from 'axios';
import qs from 'qs';

import TopBlock from './TopBlock';
import GenderField from './GenderField';
import AgeField from './AgeField';
import PostcodeField from './PostcodeField';
import SectorField from './SectorField';
import MobileButton from './MobileButton';
import RatingField from './RatingField';
import UnionMemberField from './UnionMemberField';
import RemoteWorkingField from './RemoteWorkingField';

export default class extends PureComponent {
    constructor() {
        super();
        this.setGender = this.setGender.bind(this);
        this.setAgeGroup = this.setAgeGroup.bind(this);
        this.setPostcode = this.setPostcode.bind(this);
        this.setSector = this.setSector.bind(this);
        this.setJobRating = this.setJobRating.bind(this);
        this.setUnionMember = this.setUnionMember.bind(this);
        this.setRemoteWorker = this.setRemoteWorker.bind(this);
    }

    state = {
        gender: '',
        ageGroup: '',
        postcode: '',
        sector: '',
        jobRating: '',
        unionMember: '',
        remoteWorker: '',
    };

    componentDidMount() {
        this.animatePage();
        this.props.setWhiteLogo(false);
        
    }

    animatePage() {
        const formPage = document.getElementById('FormPage');
        setTimeout(() => {
            formPage.classList.add('__active');
        }, 10);
    }

    setGender(gender) {
        this.setState({
            gender
        });
    }

    setAgeGroup(ageGroup) {
        this.setState({
            ageGroup
        });
    }

    setPostcode(postcode) {
        this.setState({
            postcode
        });
    }

    setSector(sector) {
        this.setState({
            sector
        });
    }

    setJobRating(jobRating) {
        this.setState({
            jobRating
        });
    }

    setUnionMember(unionMember) {
        this.setState({
            unionMember,
        });
    }

    setRemoteWorker(remoteWorker) {
        this.setState({
            remoteWorker
        });
    }

    submitResults = async () => {
        // Build data to send to CMS
        const { categories, soc, jobTitle, setUnion} = this.props;
        const answers = categories.map(cat => {
            return cat.subQuestions.map(subQuestion => subQuestion.answers[subQuestion.answer].title);
        });

        setUnion(this.state.unionMember);

        try {
            const data = {
                answers: [].concat.apply([], answers),
                gender: this.state.gender,
                ageGroup: this.state.ageGroup,
                postcode: this.state.postcode,
                sector: this.state.sector,
                jobRating: this.state.jobRating,
                soc,
                jobTitle,
                unionMember: this.state.unionMember,
                remoteWorker: this.state.remoteWorker
            };

            await axios.post(process.env.CMS_URL + '/submitForm', qs.stringify(data));

        } catch (e) {
            console.log(e);
        }
    }

    render() {

        return (
            <div className="formwrap" id="FormPage">
                <div className="formwrap-top">
                    <TopBlock {...this.state} submitResults={this.submitResults} />
                </div>
                <div className="formwrap-form">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="formwrap-left">
                                <div className="formwrap-field">
                                    <GenderField
                                        setGender={this.setGender}
                                        gender={this.state.gender}
                                    />
                                </div>
                                <div className="formwrap-field __second">
                                    <AgeField
                                        setAgeGroup={this.setAgeGroup}
                                        ageGroup={this.state.ageGroup}
                                    />
                                </div>
                                <div className="formwrap-field __third __last">
                                    <PostcodeField
                                        setPostcode={this.setPostcode}
                                        postcode={this.state.postcode}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="formwrap-right">
                                <div className="formwrap-field __fourth __sector">
                                    <SectorField
                                        setSector={this.setSector}
                                        sector={this.state.sector}
                                    />
                                </div>
                                <div className="formwrap-field __fifth">
                                    <UnionMemberField
                                        setUnionMember={this.setUnionMember}
                                        unionMember={this.state.unionMember}
                                    />
                                </div>
                                <div className="formwrap-field __sixth">
                                    <RemoteWorkingField
                                        setRemoteWorker={this.setRemoteWorker}
                                        remoteWorker={this.state.remoteWorker}
                                    />
                                </div>
                                <div className="formwrap-field __seventh __last">
                                    <RatingField
                                        setJobRating={this.setJobRating}
                                        jobRating={this.state.jobRating}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <MobileButton {...this.state} submitResults={this.submitResults} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Form/index.js